import React from 'react';
import PropTypes from 'prop-types';
import { C } from 'shared/helpers';

import Styles from './Etapa.module.scss';

export default function Etapa({ title, epoca, lighter, style, total }) {
  const { Etapa, Lighter } = Styles;
  return (
    <div className={C(Etapa, [lighter, Lighter])}>
      <div
        style={{
          minWidth: !total ? '150px' : '275px',
          display: 'flex',
          ...style,
        }}
      >
        {title}
      </div>
      {!total && (
        <div
          style={{
            minWidth: '125px',
            display: 'flex',
            ...style,
          }}
        >
          {epoca}
        </div>
      )}
      <div
        style={{
          minWidth: '100px',
          marginTop: '-1px',
          marginLeft: '-1px',
          ...style,
        }}
      >
        <div style={{ ...style }}>SQM VITAS</div>
        <div style={{ ...style }}>Convencional</div>
      </div>
    </div>
  );
}

Etapa.defaultProps = {
  lighter: false,
  style: {},
};

Etapa.propTypes = {
  title: PropTypes.string.isRequired,
  lighter: PropTypes.bool,
  style: PropTypes.object,
};
